// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_r8LpzA","tab":"ob_WfB2Mt","selected":"ob_WD6quF"};